import Item from './baseItem.js'
class News extends Item{
  constructor(params={}) {
    super(params);
    this.typeName = 'ニュース';
    this.className = 'News';
  }
}

export default News;